// src/pages/NotFound.jsx
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function NotFound() {
  return (
    <>
      <SEO title="404 — Page Not Found" />
      <Navbar variant="light" />
      <section style={{ padding: '128px 32px', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <div>
          <p style={{ fontSize: '120px', fontWeight: 700, color: 'var(--shades-300)', lineHeight: 1, marginBottom: '24px' }}>404</p>
          <h1 className="title-2" style={{ marginBottom: '16px' }}>Page not found</h1>
          <p className="body-lg" style={{ color: 'var(--token-desc)', maxWidth: '400px', margin: '0 auto 32px' }}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn btn-primary">Go back home</Link>
        </div>
      </section>
      <Footer />
    </>
  );
}
